module.exports = __webpack_public_path__ + "img/emoji-btn.7fc779ae.svg";